
<div class="photoFrame" #photoFrame style="position: relative;
background: url(http://www.photogearnews.com/wp-content/uploads/2017/01/Pentax-GFX-50s-3.jpg);
background-repeat: no-repeat;">
  
  <svg viewBox="0 0 200 200" style="width:100%">
      <circle cx="100" cy="100" r="50" stroke="white" stroke-width="1" fill="none" />
        <rect x="50" y="50" width="100" height="100" stroke="white" fill="none" stroke-width="1" />
    </svg>
</div>